import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import { signInWithPopup } from "firebase/auth";
import Icons from "../../assets/icons/index";
import Slider from "react-slick";
// import IntlTelInput from 'react-intl-tel-input';
import OtpInput from "react-otp-input";
// import 'react-intl-tel-input/dist/main.css';
import {
  getCurrent,
  Login,
  loginProceed,
  logoutDevice,
  otpVerifyApi,
  socialLogin,
} from "../../restApi/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { decrypt, decryptdata, encrypt, encryptdata } from "../../utils/crypto";
import { auth, firebaseData, provider } from "../../firebase";
import { getAnalytics, setUserId, setUserProperties } from "firebase/analytics";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import PhoneInput, {
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import Loader from "../common/Loader/Loader";
import { setupMoengageUser, trackEvent } from "../../utils/moengageUserSetup";
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
const INITIAL_STATE = {
  dialCode: "",
  mobile: "",
  email: "",
  messageType: "txt",
  reCaptchaCode: "",
};
const OTP_INITIAL_STATE = {
  dialCode: "",
  otpOrderNumber: "",
  otp: "",
  mobileNo: "",
  deviceId: "1692972505820sxmhipzu0m",
  isDevice: false,
  deviceModelNo: "",
  deviceVersion: 11,
  deviceType: "website",
};
export default function LogInHome() {
  let [loader, setloader] = useState(false);
  const navigate = useNavigate();
  const [preSubscription, setPreSubscription] = useState();
  const [config, setConfig] = useState();
  const [remoteLoading, setRemoteLoading] = useState(true);
  let [mob, showMobile] = useState(null);
  const [getUserNumber, setUserNumber] = useState(INITIAL_STATE);
  const [getUserOTP, setUserOTP] = useState(OTP_INITIAL_STATE);
  const [browserName, showBrowserName] = useState("");
  const [number, setValue] = useState();
  const [device, showDevice] = useState(null);
  const [loginHome, showLoginHome] = useState(true);
  const [userExiting, showExitUser] = useState(false);
  const [otpVerify, showOtp] = useState(false);
  let [dial, showDial] = useState();
  const [status, showStatus] = useState();
  const [time, setTime] = useState(0);
  const [counter, setCounter] = useState(0);
  const [orderNumber, setOrderNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [deviceShow, setDevice] = useState(false);
  const [suspendedShow, setSuspended] = useState(false);
  const [manageShow, setManage] = useState(false);
  const [deletedShow, setDeleted] = useState(false);
  const [LoginData, setLogin] = useState();
  const [mobileNumber, setMobileNumber] = useState();

  const [searchParam] = useSearchParams();

  const showDevices = () => setDevice(true);
  const hideDevices = () => setDevice(false);
  const suspendedInfo = () => setSuspended(true);
  const suspendedAccounts = () => setSuspended(false);
  const manageDevices = () => setManage(true);
  const manageHide = () => setManage(false);
  const deletedInfo = () => setDeleted(true);
  const deletedHide = () => setDeleted(false);

  const closePop = () => {
    manageDevices();
    hideDevices();
  };
  const firebaseStore = async (data) => {
    let activePackageList = data.activePackage;
    let sizeOfActiveList = activePackageList?.length;
    let activePackage = [];
    for (let i = 0; i < sizeOfActiveList; i++) {
      activePackage.push(data.activePackage[i].packageId);
    }
    let paid;
    if (sizeOfActiveList > 0) {
      paid = true;
    } else {
      paid = false;
    }
    var noOfDays = 0;
    if (data.trialEndDate) {
      let end_Date = moment(new Date());
      let start_Date = moment(data.trialEndDate); // add date in the yy / mm / dd format.
      noOfDays = end_Date.diff(start_Date, "days");
    } else {
      noOfDays = 0;
    }
    const analytics = getAnalytics();
    setUserId(analytics, data._id);
    setupMoengageUser(data);
    setUserProperties(analytics, {
      user_id: data._id,
      name: data.name,
      isNotification: data.isNotification,
      email: data.email,
      mobileNo: data.mobileNo,
      createdAt: data.createdAt,
      Version: data.version,
      countryCode: data.countryCode,
      Year: data?.batch?.year,
      country: data?.address?.country,
      collegeState: data?.address?.collegeState,
      collegeCity: data?.address?.collegeCity,
      collegeName: data?.address?.collegeName,
      course: data.preparingFor,
      collegeYear: data.collegeYear,
      isFreeTrialActivated: noOfDays > 0 ? true : false,
      packages: activePackage,
      paidUser: paid,
      role: data.role,
      trialEndDate: data.trialEndDate,
    });
  };
  const getCookie = (name) => {
    var cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  var datasetString = getCookie("dataset");
  let dataset;
  if (datasetString) {
    dataset = JSON.parse(datasetString);
    // Now, 'dataset' contains your data.
  }
  const versionSelect = (data) => {
    localStorage.setItem("version", JSON.stringify(data));
  };
  const googleSignIn = async () => {
    try {
      const { user } = await signInWithPopup(auth, provider);
      const payload = {
        deviceId: "1692972505820sxmhipzu0m",
        deviceType: "website",
        deviceModelNo: getBrowserDetails(),
        deviceVersion: 11,
        isDevice: true,
      };
      // console.log(payload,"payload")
      setloader(true);
      const loginviagoogle = await socialLogin(payload, user.accessToken);
      const resolveResponse = await loginviagoogle.json();
      const UserData = JSON.parse(decrypt(resolveResponse));
      if (UserData.data.code === 1) {
        setloader(false);
        let value = encryptdata(UserData.data.result.Token);
        let did = encryptdata(getDeviceId());
        localStorage.setItem("token", value);
        localStorage.setItem("dId", did);
        showToast(UserData.data.message);
        currentList();
      }
      if (UserData.data.code === 0) {
        setloader(false);
        showToastError(UserData.data.message);
      }
      if (UserData.data.code === 2) {
        setloader(false);
        showToastError(UserData.data.message);
      }
      if (UserData.data.code === 4) {
        setloader(false);
        showDevices();
        setLogin(UserData.data.result);
      }
      if (UserData.data.code === 8) {
        setloader(false);
        showDial("");
        setValue("");
        handleInputChange("", "mobile");
        showMobile("");
        suspendedInfo();
      }
      if (UserData.data.code === 56) {
        setloader(false);
        showDial("");
        setValue("");
        handleInputChange("", "mobile");
        showMobile("");
        deletedInfo();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const languageSelect = (data) => {
    localStorage.setItem("language", JSON.stringify(data));
  };

  const login_proceed = async () => {
    await loginProceed(LoginData?.Token)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let req = data;
        if (req.data.code == 1) {
          // getDeviceId()
          let value = encryptdata(LoginData?.Token);
          let did = encryptdata(getDeviceId());
          localStorage.setItem("token", value);
          localStorage.setItem("dId", did);
          currentList();
        } else if (req.data.code == 4) {
          manageDevices();
        }
      });
  };

  const logout_devices = async (d, index) => {
    let data = {
      deviceId: d.deviceId,
      isSelf: true,
      isAllLogout: false,
      userId: d.user,
    };
    await logoutDevice(data)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let req = JSON.parse(decrypt(data));
        if (req.data.code == 1) {
          LoginData && LoginData?.numberOfDevice.splice(index, 1);
          login_proceed();
        } else if (req.data.code == 4) {
          manageDevices();
        }
      });
  };

  const currentList = async () => {
    await getCurrent()
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let req = JSON.parse(decrypt(data));

        let user = req.data.result;
        let profileDetails = {
          id: user._id,
          name: user.name,
          avatar: user.avatar,
          country: user?.address?.country,
          email: user.email,
          collegeCity: user?.address?.collegeCity,
          collegeName: user?.address?.collegeName,
          collegeState: user?.address?.collegeState,
          collegeYear: user.collegeYear,
          batch: user?.batch?._id,
          mobileNo: user.mobileNo,
          preparingFor: user.preparingFor,
        };
        // trackEvent("login_success", user);
        trackEvent("loginSuccess", { "source": "web" });

        firebaseStore(req.data.result);
        localStorage.setItem(
          "profileDetails",
          encrypt(
            JSON.stringify(profileDetails) != "{}"
              ? JSON.stringify(profileDetails)
              : undefined
          )
        );
        const packageStatus = JSON.stringify({
          activePackageLength: user?.activePackage?.length,
          isTrialUser: user?.isTrialUser,
        });
        localStorage.setItem("packageStatus", encrypt(packageStatus));
        let version = [];
        config &&
          config?.courses.map((o) => {
            if (o.title === user.preparingFor) {
              version = o.versions;
              return;
            }
          });
        languageSelect("English");
        versionSelect(version[0]);
        if (searchParam.get("plan")) {
          navigate(`/package/plan/${searchParam.get("plan")}`);
        } else if (searchParam.get("shop")) {
          navigate(`/package/planAddons/${searchParam.get("shop")}`);
        } else if (searchParam.get("notes")) {
          navigate(`/package/${searchParam.get("notes")}`);
        } else {
          navigate("/videolayer");
        }
      })
      .catch((error) => {
        localStorage.clear();
        navigate("/onboarding/login");
      });
  };

  useEffect(() => {
    console.log();
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      "recaptcha-key",
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      function () {
        console.log("Script loaded!");
      }
    );
    return () => {
      const script = document.getElementById("recaptcha-script");
      if (script) {
        script.remove();
      }
    };
  }, []);

  useEffect(() => {
    const getConfigData = async () => {
      try {
        const remoteData = await firebaseData("settings_config"); // Replace 'your_config_key' with the actual key for the configuration value you want
        setConfig(JSON.parse(remoteData));
        setRemoteLoading(false);
      } catch (error) {
        console.error("Error fetching remote data:", error);
        setRemoteLoading(false);
      }
    };

    if (typeof window !== "undefined") {
      getConfigData();
    }
  }, []);
  useEffect(() => {
    document.body.className = "signup";
    return () => {
      document.body.className = "";
    };
  });
  useEffect(() => {
    const timer = schedule();
    return () => {
      clearInterval(timer);
    };
  }, [counter]);

  const schedule = () => {
    const time =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return time;
  };

  const handleInputChange = function (fieldValue, fieldName) {
    getUserNumber.mobile = mob;
    getUserNumber.dialCode = "+" + dial;
    setUserNumber({ ...getUserNumber, [fieldName]: fieldValue });
  };
  const handleOtpChange = function (fieldValue, fieldName) {
    getUserOTP.otp = otp;
    getUserOTP.otpOrderNumber = orderNumber;
    getUserOTP.dialCode = "+" + dial;
    getUserOTP.mobileNo = mob;
    getUserOTP.deviceModelNo = browserName;
    getUserOTP.deviceId = device;
    setUserOTP({ ...getUserOTP, [fieldName]: fieldValue });
  };
  const handlePhoneNumberChange = (value) => {
    if (value !== undefined) {
      setValue(value);
      let validate = isValidPhoneNumber(value);
      if (validate) {
        let data = parsePhoneNumber(value);
        mob = data?.nationalNumber;
        showMobile(data?.nationalNumber);
        handleInputChange(data?.nationalNumber, "mobile");
        if (data?.countryCallingCode === "91") {
          if (data?.nationalNumber.length === 10) {
            showStatus(validate);
            dial = data?.countryCallingCode;
            showDial(data?.countryCallingCode);
            handleInputChange("+" + dial, "dialCode");
          } else {
            showStatus(false);
          }
        } else {
          showStatus(validate);
          dial = data?.countryCallingCode;
          showDial(data?.countryCallingCode);
          handleInputChange("+" + dial, "dialCode");
        }
      } else {
        showStatus(false);
      }
    }
  };
  const gotologin = async () => {
    suspendedAccounts();
    deletedHide();
    showDial("");
    handleInputChange("", "mobile");
    showMobile("");
    showLoginHome(true);
    showOtp(false);
    showExitUser(false);
  };

  const otpSent = async (e) => {
    setloader(true);
    handleOtpChange();
    handleOTPsubmit(e);
  };

  const handleChange = (value) => {
    if (value != undefined) {
      let validate = isValidPhoneNumber(value);
      if (validate) {
        let data = parsePhoneNumber(value);
        showDial(data?.countryCallingCode);
        handleInputChange(data?.nationalNumber, "mobile");
        showMobile(data?.nationalNumber);
        showStatus(validate);
      } else {
        showStatus(false);
      }
    }
  };

  const showToast = (message) => {
    toast.success(message);
  };

  const showToastError = (message) => {
    toast.error(message);
  };

  const handleSubmit = async (e) => {
    setOtp("");
    const getToken = async () => {
      return new Promise((resolve, reject) => {
        window.grecaptcha.ready(async () => {
          try {
            const token = await window.grecaptcha.execute(SITE_KEY, {
              action: "submit",
            });
            resolve(token);
          } catch (error) {
            reject(error);
          }
        });
      });
    };
    // try {
    //     window.grecaptcha.ready(() => {
    //         window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
    //             console.log("token", dial)
    //             if (dial == '91') {

    //                 handleInputChange('', 'reCaptchaCode')
    //             }
    //             else {
    //                 getUserNumber.reCaptchaCode = token
    //                 handleInputChange(token, 'reCaptchaCode')
    //             }
    //             console.log([getUserNumber], { INITIAL_STATE })

    //         });
    //     });
    // } catch {

    // }

    try {
      const token = await getToken();
      console.log("token", token);

      if (dial === "91") {
        getUserNumber.reCaptchaCode = "";
        // handleInputChange('', 'reCaptchaCode');
      } else {
        getUserNumber.reCaptchaCode = token;
        handleInputChange(token, "reCaptchaCode");
      }

      // console.log(getUserNumber, INITIAL_STATE);
    } catch (error) {
      console.error("Error:", error);
    }

    if (dial != "" && mob != "") {
      if (status == true) {
        setloader(true);
        e.preventDefault();
        const res = await Login(getUserNumber)
          .then((response) => {
            return response.json();
          })
          .then((req) => {
            console.log(req, "login response");
            //    let req= JSON.parse(decrypt(data))
            if (req.data.code != 1) trackEvent("login_error", { "source": "web", "status": req.data.code })
            if (req.data.code == 1) {
              setloader(false);
              showToast("OTP Sent Successfully");
              setTime(parseInt(30));
              setCounter(parseInt(30));
              setOrderNumber(req.data.result.otpOrderNumber);
              showLoginHome(false);
              showExitUser(false);
              showOtp(true);
              getDeviceId();
              getBrowserDetails();
            } else if (req.data.code == 0) {
              setloader(false);
              showToastError(req.data.message);
            } else if (req.data.code == 4) {
              setloader(false);
              showDevices();
              setLogin(req.data.result);
            } else if (req.data.code == 8) {
              setloader(false);
              showDial("");
              setValue("");
              handleInputChange("", "mobile");
              showMobile("");
              suspendedInfo();
            } else if (req.data.code == 56) {
              setloader(false);
              showDial("");
              setValue("");
              handleInputChange("", "mobile");
              showMobile("");
              deletedInfo();
            }
          });
      } else {
        setloader(false);
        showToastError("Invalid Mobile Number");
      }
    } else {
      setloader(false);
      showToastError("Invalid Mobile Number");
    }
  };

  const getBrowserDetails = () => {
    let browser;
    let userAgent = navigator.userAgent;
    if (userAgent.match(/chrome|chromium|crios/i)) {
      browser = "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      browser("firefox");
    } else if (userAgent.match(/safari/i)) {
      browser = "safari";
    } else if (userAgent.match(/opr\//i)) {
      browser = "opera";
    } else if (userAgent.match(/edg/i)) {
      browser = "edge";
    } else {
      browser = "No browser detection";
    }
    showBrowserName(browser);
    return browser;
  };

  const getDeviceId = () => {
    let did = decryptdata(localStorage.getItem("dId"));
    if (did !== undefined && did !== "" && did !== null && did !== "null") {
      let deviceId = did;
      showDevice(deviceId);
      return;
    }
    // let r = (Math.random() + 1).toString(36).substring(2);
    // let deviceId = Date.now().toString() + r;
    let deviceId = "1692972505820sxmhipzu0m";
    showDevice(deviceId);
    return deviceId;
  };

  const backfunction = async () => {
    showDial("");
    setValue("");
    handleInputChange("", "mobile");
    showMobile("");
    showLoginHome(true);
    showOtp(false);
    showExitUser(false);
  };
  const register = async () => {
    showExitUser(true);
    showLoginHome(false);
    showOtp(false);
  };

  var settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleOTPsubmit = async (e) => {
    console.log(e);
    // console.log(counter,"counter");
    if (counter == 0) {
      setloader(false);
      showToastError("OTP expired");
      setOtp("");

    } else {
      e.preventDefault();
      const res = await otpVerifyApi(getUserOTP)
        .then((response) => {
          console.log(response)
          trackEvent("loginError", { "source": "web" });

          return response.json();
        })
        .then((req) => {
          // let req= JSON.parse(decrypt(data))
          if (req.data.code == 1) {
            setloader(false);
            let value = encryptdata(req.data.result.Token);
            let did = encryptdata(device);
            localStorage.setItem("token", value);
            localStorage.setItem("dId", did);
            showToast(req.data.message);
            currentList();
          } else if (req.data.code == 2) {
            navigate("/onboarding/signup");
            let data = {
              mobile: mob,
              dial: dial,
              otpOrder: orderNumber,
            };
            // let value= encryptdata(data)
            localStorage.setItem("data", JSON.stringify(data));
          } else if (req.data.code == 0) {
            setloader(false);
            setOtp("");
            showToastError(req.data.message);
          } else if (req.data.code == 4) {
            setloader(false);
            showDevices();
            setLogin(req.data.result);
            // showToastError(req.data.message)
          } else if (req.data.code == 8) {
            setloader(false);
            showDial("");
            setValue("");
            handleInputChange("", "mobile");
            showMobile("");
            suspendedInfo();
            // showToastError(req.data.message)
          } else if (req.data.code == 56) {
            setloader(false);
            showDial("");
            setValue("");
            handleInputChange("", "mobile");
            showMobile("");
            deletedInfo();
            // showToastError(req.data.message)
          }
        });
    }
  };
  if (loader) {
    return (
      <>
        <Loader />
      </>
    );
  }
  return (
    <>
      <section className="signup_wrapper login_wrapper">
        <ToastContainer />
        <div className="register_container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="slider_wrapper text-center">
                <Slider {...settings}>
                  <div className="slider_content">
                    <figure className="slide_img">
                      <img src={Images.LoginImg} alt="" className="img-fluid" />
                    </figure>
                    <div className="img_text">
                      <h5>We Care for Your Preparation</h5>
                      <p>Specially curated lectures by our Gurus</p>
                    </div>
                  </div>
                  <div className="slider_content">
                    <figure className="slide_img">
                      <img
                        src={Images.LoginImg2}
                        alt=""
                        className="img-fluid"
                      />
                    </figure>
                    <div className="img_text">
                      <h5>We Care for Your Understanding</h5>
                      <p>High-yield QBank & MCQs</p>
                    </div>
                  </div>
                  <div className="slider_content">
                    <figure className="slide_img">
                      <img
                        src={Images.LoginImg3}
                        alt=""
                        className="img-fluid"
                      />
                    </figure>
                    <div className="img_text">
                      <h5>We Care for You</h5>
                      <p>We are there with you, till the end</p>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="login_content">
                {loginHome && (
                  <div className="login_home">
                    <h3>Welcome to eGurukul</h3>
                    <div className="existing_usr">
                      <h6>Existing Student?</h6>
                      <p>Login using mobile or google</p>
                    </div>
                    <div className={`input_box pos_rel`}>
                      <PhoneInput
                        defaultCountry="IN"
                        autoFormat={false}
                        placeholder="Enter mobile number"
                        value={number}
                        initialValueFormat="national"
                        enableLongNumbers={true}
                        maxLength={dial === "91" ? 11 : 16}
                        minLength={6}
                        disableCountryGuess={true}
                        disableInitialCountryGuess={true}
                        onChange={handlePhoneNumberChange}
                        style={{
                          border: status == false ? "1px solid red" : "",
                        }}
                      />
                      {status == false && (
                        <span style={{ color: "#DC3F16", fontSize: "12px" }}>
                          {"Invalid Mobile number"}
                        </span>
                      )}
                      <span className="get_otp" onClick={handleSubmit}>
                        Get OTP
                      </span>
                    </div>
                    <div className="sep_wrapper">
                      <span className="separator">Or</span>
                    </div>
                    <div className="login_with_google">
                      <button
                        type="button"
                        className="btn btn_google"
                        target="_blank"
                        onClick={googleSignIn}
                      >
                        <img
                          src={Images.Google}
                          alt="Google"
                          className="img-fluid"
                        />{" "}
                        Login with Google
                      </button>
                    </div>
                    <div className="register_usr">
                      <h6>
                        New Student?{" "}
                        <a
                          href="javascript:;"
                          className="register_btn"
                          onClick={register}
                        >
                          Register Now{" "}
                          <img
                            src={Icons.ArrowBlue}
                            alt=""
                            className="img-fluid"
                          />
                        </a>
                      </h6>
                    </div>
                    <br></br>
                    {/* <small>This site is protected by reCAPTCHA and the Google 
                                                <a href="https://policies.google.com/privacy">Privacy Policy</a> and
                                                <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                                            </small> */}
                  </div>
                )}
                {userExiting && (
                  <div className="login_home">
                    <div className="exit_user d-flex align-items-baseline">
                      <figure className="exit_arrow" onClick={backfunction}>
                        <img
                          src={Icons.ArrowLeftBg}
                          alt=""
                          className="img-fluid"
                        />
                      </figure>
                      <h3>Welcome to eGurukul</h3>
                    </div>
                    <div className="existing_usr">
                      <h6>New Student?</h6>
                      <p>Register using your mobile number</p>
                    </div>
                    <div className={`input_box pos_rel`}>
                      <PhoneInput
                        defaultCountry="IN"
                        autoFormat={false}
                        initialValueFormat="national"
                        placeholder="E.g. 999 999 1111"
                        value={number}
                        maxLength={dial === "91" ? 11 : 16}
                        minLength={6}
                        disableCountryGuess={true}
                        disableInitialCountryGuess={true}
                        onChange={handlePhoneNumberChange}
                        style={{
                          border: status == false ? "1px solid red" : "",
                        }}
                      />
                      {status == false && (
                        <span style={{ color: "#DC3F16", fontSize: "12px" }}>
                          {"Invalid Mobile number"}
                        </span>
                      )}
                      <span className="get_otp" onClick={handleSubmit}>
                        Get OTP
                      </span>
                    </div>
                  </div>
                )}
                {otpVerify && (
                  <div className="login_home">
                    <div className="exit_user d-flex align-items-baseline">
                      <figure className="exit_arrow" onClick={backfunction}>
                        <img
                          src={Icons.ArrowLeftBg}
                          alt=""
                          className="img-fluid"
                        />
                      </figure>
                      <h3>OTP Verification</h3>
                    </div>
                    <div className="existing_usr otp_number">
                      <p>
                        We’ve sent an OTP to <span>{"+" + dial + mob}</span>
                        <img
                          src={Icons.Edit}
                          alt=""
                          className="img-fluid"
                          onClick={backfunction}
                        />
                      </p>
                    </div>
                    <div className="otp_boxes">
                      <p>Enter OTP</p>
                      <div className="boxes">
                        <OtpInput
                          inputType="tel"
                          value={otp}
                          onChange={setOtp}
                          numInputs={4}
                          renderSeparator={<span></span>}
                          renderInput={(props) => <input {...props} />}
                        />
                      </div>
                      {counter > 0 && (
                        <span className="resend">
                          Resend OTP in 00:{counter}
                        </span>
                      )}
                      {counter == 0 && (
                        <a
                          href="javascript:;"
                          className="resend_link"
                          onClick={handleSubmit}
                        >
                          Resend OTP{" "}
                          <img
                            src={Icons.ArrowBlue}
                            alt="Resend"
                            className="img-fluid"
                          />
                        </a>
                      )}
                    </div>
                    <div className="verify_btn">
                      <button
                        type="button"
                        className="btn btn_verify"
                        onClick={otpSent}
                      >
                        Verify OTP
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        show={deviceShow}
        onHide={hideDevices}
        backdrop="static"
        className="detail_modal report_modal device_reached"
        centered
      >
        <Modal.Body>
          <div className="account_option_wrapper">
            {/* <div className="cross_icon text-right">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideDevices}/>
                </div> */}
            <div className="account_header text-center">
              <h6>Maximum Devices Reached</h6>
              <p>
                You have reached the maximum number of devices for your account.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="rating_submit">
            <button
              type="button"
              className="btn btn_theme btn_border"
              onClick={hideDevices}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn_theme" onClick={closePop}>
              Manage Devices
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={manageShow}
        onHide={manageHide}
        backdrop="static"
        className="detail_modal report_modal device_reached"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <h4>Manage Devices</h4>
            {/* <span className="cross_icon">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={manageHide}/>
                </span> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="account_option_wrapper">
            <ul type="none">
              {LoginData &&
                LoginData?.numberOfDevice.map((obj, ind) => (
                  <li>
                    <div className="all_devices d-flex align-items-center justify-content-between">
                      <div className="device_names">
                        <h6>{obj.deviceModelNo}</h6>
                        <img
                          src={Images.Globe}
                          alt="Globe"
                          className="img-fluid"
                        />
                        <span>{obj.deviceType}</span>
                      </div>
                      <div
                        className="device_del"
                        onClick={() => logout_devices(obj, ind)}
                      >
                        <img
                          src={Icons.Delete}
                          alt="Globe"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </li>
                ))}
              {/* <li>
                        <div className="all_devices d-flex align-items-center justify-content-between">
                            <div className="device_names">
                                <h6>iPhone14,3</h6>
                                <img src={Icons.Apple} alt="Globe" className="img-fluid"/>
                                <span>iOS</span>
                            </div>
                            <div className="device_del">
                                <img src={Icons.Delete} alt="Globe" className="img-fluid"/>
                            </div>
                        </div>
                    </li> */}
            </ul>
            <div className="device_notification text-center">
              <p>
                You cannot add more than 2 device.
                <br />
                Please delete one to login to current device.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="rating_submit">
            <button
              type="button"
              className="btn btn_theme btn_border"
              onClick={manageHide}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn_theme">
              Ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={suspendedShow}
        onHide={suspendedAccounts}
        backdrop="static"
        className="detail_modal report_modal device_reached"
        centered
      >
        <Modal.Body>
          <div className="account_option_wrapper">
            {/* <div className="cross_icon text-right">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideDevices}/>
                </div> */}
            <div className="account_header text-center">
              <h6>Account Suspended!!</h6>
              <p>
                You are blocked by admin, please contact admin for more details
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="rating_submit">
            <button
              type="button"
              className="btn btn_theme btn_border"
              onClick={suspendedAccounts}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn_theme" onClick={gotologin}>
              Ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={deletedShow}
        onHide={deletedHide}
        backdrop="static"
        className="detail_modal report_modal device_reached"
        centered
      >
        <Modal.Body>
          <div className="account_option_wrapper">
            {/* <div className="cross_icon text-right">
                    <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideDevices}/>
                </div> */}
            <div className="account_header text-center">
              <h6>Account Deleted!!</h6>
              <p>
                You account has been deleted, please contact admin to reactive.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="rating_submit">
            <button
              type="button"
              className="btn btn_theme btn_border"
              onClick={deletedHide}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn_theme" onClick={gotologin}>
              Ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
